<template>
  <BaseModal modal-content-class="rest confirm_purch">
    <div class="content">
      <h1>{{ $_translations.value.modal_purchase_error_title }}</h1>

      <BaseImage
        src="/static/images/store/store_failed_icon.svg"
        alt="pin icon"
        image-class="top_img"
      />

      <p class="mt-40">{{ $_translations.value.modal_purchase_error_result }}</p>

      <p>{{ $_translations.value.modal_purchase_error_description }}</p>

      <BaseButton button-class="fancy_btn close_modal">
        {{ $_translations.value.modal_purchase_error_button_proceed }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
</script>
